// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  electionId: __t.u64().primaryKey().name("election_id"),
  cityId: __t.u64().name("city_id"),
  opensAt: __t.timestamp().name("opens_at"),
  closesAt: __t.timestamp().name("closes_at"),
  winner: __t.identity(),
  resolved: __t.bool(),
});
